import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { FileFieldCell } from '@/components/table/_fieldDefinitions/file/FileFieldCell.tsx';
import { LinkFieldCell } from '@/components/table/_fieldDefinitions/linkOrFile/LinkFieldCell.tsx';
import { MissingFileIcon } from '@/components/table/_fieldDefinitions/linkOrFile/MissingFileIcon.tsx';
import {
  LinkOrFileCellDto,
  LinkOrFileType,
} from '@/components/table/_fieldDefinitions/linkOrFile/LinkOrFileCellDto.ts';

interface LinkOrFileFieldCellProps {
  value: LinkOrFileCellDto | null | undefined;
}

export const LinkOrFileFieldCell = ({ value }: LinkOrFileFieldCellProps) => {
  if (!value) {
    return <MissingFileIcon />;
  }
  if (value.type === LinkOrFileType.FILE) {
    if (value.file) {
      return <FileFieldCell file={value.file} />;
    }
    return <MissingFileIcon />;
  }
  if (value.type === LinkOrFileType.LINK && value.linkUrl) {
    return <LinkFieldCell url={value.linkUrl} />;
  }
  return <EmptyValue />;
};
